var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"background"}),_c('a-spin',{staticStyle:{"z-index":"1"},attrs:{"size":"large","tip":_vm.message}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }